import React from 'react';
import { Route } from 'react-router-dom';
import AdDetails from './ads/AdDetails';
import AdPlans from './ads/AdPlans';
import AdComplete from './ads/AdComplete';

export default [
    <Route path="/member/ad_detail/:adId" component={AdDetails} />,
    <Route path="/member/ad_plans/:adId" component={AdPlans} />	,
    <Route path="/member/ad_complete/:adId" component={AdComplete} />	
];


// WEBPACK FOOTER //
// ./src/routes.js